import type { OnbOptionType } from '../../../../types';
import type { LayoutDataType } from '../../types';

export const OPTIONS: OnbOptionType<LayoutDataType['gender']>[] = [
  {
    id: 'women',
    title: 'WOMAN',
  },
  {
    id: 'man',
    title: 'MAN',
  },
  {
    id: 'non-binary',
    title: 'NON-BINARY PERSON',
  },
];
